import React from 'react';
import styled from '@emotion/styled';
import NotificationIcon from '../../../../components/Icons/NotificationIcon';

const Upcoming = () => {
  return (
    <Container>
      <p>Upcoming</p>

      <Ul>
        <li>
          <NotificationIcon color="#27AE60" bg="#EFFBF6" />
          <p>
            <span>Interview with Dr. Alabi and Dr. Sola </span>
            <span>Aug, 11 ‘23 || 11:30AM - 12:30PM</span>
          </p>
        </li>
        <li>
          {' '}
          <NotificationIcon color="#E2B93B" bg="#FEF9EC" />
          <p>
            <span>Interview with Dr. Alabi and Dr. Sola </span>
            <span>Aug, 11 ‘23 || 11:30AM - 12:30PM</span>
          </p>
        </li>
        <li>
          {' '}
          <NotificationIcon color="#E2B93B" bg="#FEF9EC" />
          <p>
            <span>Interview with Dr. Alabi and Dr. Sola </span>
            <span>Aug, 11 ‘23 || 11:30AM - 12:30PM</span>
          </p>
        </li>
      </Ul>
    </Container>
  );
};

export default Upcoming;

const Container = styled.div`
  width: 100%;
  padding-bottom: 2rem;
  border-bottom: 1px solid #e8e8e8;
  max-width: 270px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: 1rem;

  & > p {
    font-weight: 500;
    font-size: 18px;
    line-height: 100%;
    letter-spacing: -1px;
  }
`;

const Ul = styled.ul`
  list-style: none;
  padding: 0;
  margin: 0;
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: 1.7rem;

  & li {
    display: flex;
    gap: 0.7rem;

    & > svg {
      min-width: 32px;
    }

    & > p {
      display: flex;
      flex-direction: column;
      gap: 0.7rem;

      & span {
        font-weight: 400;
        font-size: 14px;
        line-height: 100%;
        letter-spacing: -1px;
      }

      & > span:nth-of-type(2) {
        font-size: 14px;
        line-height: 100%;
        letter-spacing: -1px;
      }
    }
  }
`;
